import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import authService from 'api/auth.service';
import LoginForm from 'pages/login/components/LoginForm';
import HeroSection from 'pages/login/components/HeroSection';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check if user is already authenticated
    if (authService.isAuthenticated()) {
      // Redirect to intended destination or dashboard
      const from = location.state?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [navigate, location.state?.from?.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <div className="flex min-h-screen">
        {/* Left Side - Login Form */}
        <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="mx-auto w-full max-w-md">
            <LoginForm />
          </div>
        </div>

        {/* Right Side - Hero Section (Desktop Only) */}
        <HeroSection />
      </div>
    </div>
  );
};

export default Login;
